import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  > button {
    margin-bottom: 2rem;
  }
`;
